import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-internal-server-error',
  templateUrl: './page-internal-server-error.component.html'
})
export class PageInternalServerErrorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
